/**
 * Utility for converting hexadecimal-encoded strings into parsed JavaScript values.
 *
 * @module utils/hexToString
 * @author Snowfly
 * @version 1.0.0
 */

/**
 * Converts a hexadecimal string to its corresponding string representation.
 * The input hexadecimal string is treated as a JSON-encoded string.
 * Each pair of hex digits in the input is interpreted as a character
 * in the resulting string.
 *
 * @param {string} hex - The hexadecimal string to be converted.
 * @returns {any} The parsed JSON object resulting from the string conversion.
 * @throws {SyntaxError} If the resulting string is not valid JSON.
 */
export const hexToString = (hex) => {
    let string = '';
    for (let i = 0; i < hex.length; i += 2) {
        const hexVal = hex.substring(i, i + 2),
            decVal = parseInt(hexVal, 16);
        string += String.fromCharCode(decVal);
    }
    return JSON.parse(string);
};

export default hexToString;
